/**
 * ToolBarFactory builds buttons for toolbar.
 * There are some predefined buttons (button, select, scroller, ...).
 * It's possible to provide custom button by giving a constructor instead of a string on command.type.
 */
fx.ns("desktop.common.toolbar", class ToolBarFactory {

    constructor(model){
        this.model = model;
    }
    
    create(command, component, toolBar) 
    {
        let element;
    
        switch(command.type)
        {
            case "button":
                element = new shared.stage.ToolBarButton( command, component, toolBar);
                break;

            case "select":
                element = new desktop.common.toolbar.ToolBarSelect( command, component, toolBar);
                break;

            case "font-select":
                element = new desktop.common.toolbar.ToolBarSelectFont( command, component, toolBar);
                break;

            case "scroller":
                element = new desktop.common.toolbar.ToolBarScrollerButton( command, component, toolBar);
                break;
            case "brightness":
                element = new desktop.common.toolbar.ToolBarBrightnessSelector( command, component, toolBar, this.model);
                break;
            case "state-button":
                element = new shared.stage.ToolBarStateButton( command, component, toolBar);
                break;

            case "colorpicker":
                element = new desktop.common.toolbar.ToolBarColorPickerButton( command, component, toolBar);
                break;
            
            case "text" :
                element = new desktop.common.toolbar.ToolBarText(command, component, toolBar, toolBar);
                break;
            
            case "unique-state-buttons" :
                element = new desktop.common.toolbar.ToolBarUniqueStateButtons(command, component, toolBar);
                break;

            case "fontsize-button":
                element = new desktop.common.toolbar.ToolBarFontSizeButton(command, component, toolBar);
                break;

            default:
                if (typeof command.type == "function")
                    element = new command.type(command, component, toolBar);
                else
                    element = new fx.components.Box("separator");
                break;
        }
       
        

        command.id = element.id;

        return element;
                
    }

  });